import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { StripeAccountsService } from '../services/stripe-accounts.service';
import { IStripeAccount } from '../types/api-response/stripe-account';

@Injectable()
export class StripeAccountResolver implements Resolve<Observable<IStripeAccount[]>> {
    constructor(
        private stripeAccountService: StripeAccountsService,
    ) {}

    /**
     * Resolves number of resident patches
     *
     * for building ID
     */
    resolve(route: ActivatedRouteSnapshot): Observable<IStripeAccount[]> {
        return this.stripeAccountService.stripeAccounts$;
    }
}



// WEBPACK FOOTER //
// /app/src/app/resolvers/stripe-account.resolver.ts